import { FC } from 'react'
import { Link } from 'react-router-dom'

import './style.scss'

type CardLinkProps = {
  className?: string,
  style?: any,
  to: string
}

const CardLink:FC<CardLinkProps> = ({ children, className = '', style,  to = '' }) => {
  return (
    <Link to={to} className={`card-link ${className}`} style={style}>{children}</Link>
  )
}

export { CardLink }